import { useContext } from 'react';
import { createContext } from 'react';

import { ProductRatingInlineProps } from '../@types/ProductRatingInlineProps';

export const ProductRatingInlineContext = createContext<ProductRatingInlineProps>({} as ProductRatingInlineProps);

ProductRatingInlineContext.displayName = 'ProductRatingInline';

const ProductRatingInlineProvider = (props: ProductRatingInlineProps) => (
	<ProductRatingInlineContext.Provider value={props}>{props.children}</ProductRatingInlineContext.Provider>
);

export const useProductRatingInline = () => {
	const context = useContext(ProductRatingInlineContext);

	return context;
};

export default ProductRatingInlineProvider;
